import { gql } from '@apollo/client'

const SearchYouTube = gql`
    query SearchYouTube($query: String!) {
        searchYouTube(query: $query) {
            fromCache
            query
            videos {
                videoId
                title
                channelTitle
                duration
                durationSeconds
                thumbnailUrl
                description
                publishedAt
            }
        }
    }
`

export default SearchYouTube

